const NON_PRODUCTION_ENVS = ["development", "staging"];

export function isNonProduction() {
  return NON_PRODUCTION_ENVS.includes(process.env.REACT_APP_ENV);
}
